import { caseApi } from 'modules/cm/api';
import { CaseId } from 'modules/cm/api/cases/types';
import { Dispatch } from 'redux';
import { Investment, InvestmentField } from '../../Investment';

type InvestmentToUpdate = Pick<Investment, InvestmentField.Id> & Partial<Omit<Investment, InvestmentField.Id>>;

const updateInvestmentUseCase = (caseId: CaseId, { id, ...investment }: InvestmentToUpdate) => {
  const api = caseApi(caseId).repaymentStrategyApi.investment;
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      await api.update(id, investment);
    } catch (error) {}
  };
};

export default updateInvestmentUseCase;
